module.exports = __webpack_public_path__ + "img/2.49e8f746.svg";